module.exports = __webpack_public_path__ + "static/img/hand_feel.ed1f3b42.png";